import { useState } from "react"

import { ContentObjectItem } from "@vertesia/common"
import { Trash } from "lucide-react"

import { ActionTooltipButton } from "@/components/buttons/ActionTooltipButton"
import { DeleteDocumentModal } from "@/components/modals/DeleteDocumentModal"

interface DeleteDocumentButtonProps {
    document: ContentObjectItem
    onDelete: () => void
}
export function DeleteDocumentButton({ document, onDelete }: Readonly<DeleteDocumentButtonProps>) {
    const [open, setOpen] = useState(false)

    const handleOnOpen = () => {
        setOpen(true)
    }

    return (
        <>
            <ActionTooltipButton icon={<Trash />} variant="outline" tooltip='Delete Document' onClick={handleOnOpen} />
            <DeleteDocumentModal document={document} open={open} setOpen={setOpen} onDelete={onDelete} />
        </>
    )
}